import { render, staticRenderFns } from "./echat.vue?vue&type=template&id=bb917034&scoped=true"
import script from "./echat.vue?vue&type=script&lang=js"
export * from "./echat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb917034",
  null
  
)

export default component.exports